// extracted by mini-css-extract-plugin
export var center = "signup-module--center--6efd8";
export var emailInput = "signup-module--emailInput--a4d73";
export var form = "signup-module--form--aa1b3";
export var message = "signup-module--message--69cb7";
export var signup = "signup-module--signup--1334c";
export var submitButton = "signup-module--submitButton--1d027";